import { useState } from "react";
import { TextField, IconButton, InputAdornment, Box } from "@mui/material";
import { SearchIcon } from "./icons";

interface SearchInputProps {
  query: string;
  onSearch: (query: string) => void;
  placeholder?: string;
}

export const SearchInput = ({
  query,
  onSearch,
  placeholder = "Search",
}: SearchInputProps) => {
  //const [searchValue, setSearchValue] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(e.target.value);
  };

  // const handleClear = () => {
  //   setSearchValue("");
  //   onSearch("");
  // };

  /*const handleSearch = () => {
    onSearch(searchValue);
  };*/

  const toggleExpand = () => setIsExpanded(true);

  return (
    <Box>
      <TextField
        value={query}
        onChange={handleChange}
        onClick={toggleExpand}
        placeholder={placeholder}
        variant="outlined"
        size="small"
        sx={{
          transition: "width 0.3s ease",
          minWidth: "50px",
          width: isExpanded ? "200px" : "50px",
          "& .MuiOutlinedInput-root": {
            paddingLeft: isExpanded ? "10px" : "0px",
            "& fieldset": {
              borderColor: "#7B7B7B",
              borderRadius: "8px",
            },
            "& .MuiInputBase-input": {
              padding: "4px",
            },
          },
        }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position={isExpanded ? "end" : "start"}>
                <IconButton onClick={() => onSearch(query)} size="small">
                  <SearchIcon width={24} height={24} />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
};
